import { render, staticRenderFns } from "./TopbarBack.vue?vue&type=template&id=7b0bba2a&scoped=true"
import script from "./TopbarBack.vue?vue&type=script&lang=js"
export * from "./TopbarBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0bba2a",
  null
  
)

export default component.exports